var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 40,
    viewBox: "0 0 23 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.879519 39.1195C0.316364 38.5556 0 37.7909 0 36.9935C0 36.1961 0.316364 35.4313 0.879519 34.8674L15.7491 19.9818L0.879519 5.0963C0.332323 4.52914 0.0295429 3.76952 0.0363865 2.98105C0.0432301 2.19257 0.359154 1.43834 0.916111 0.880779C1.47307 0.323227 2.2265 0.00696564 3.01413 0.000114441C3.80175 -0.00673676 4.56056 0.296371 5.12711 0.844151L22.1205 17.8558C22.6836 18.4197 23 19.1844 23 19.9818C23 20.7792 22.6836 21.544 22.1205 22.1079L5.12711 39.1195C4.56378 39.6833 3.79985 40 3.00331 40C2.20677 40 1.44284 39.6833 0.879519 39.1195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector12);
export default __webpack_public_path__ + "static/media/vector-12.d2675b0225941fab1985c892a8b293cc.svg";
export { ForwardRef as ReactComponent };